import { PageHero, CtaSection } from "../components/Sections";
import { GlowLayer } from "../components/Decor";
import Seo from "../components/Seo";
import { VALUES, APPROACH, SYSTEMS, IMAGES, PAGE_SEO } from "../lib/data";

export default function About() {
  return (
    <>
      <Seo {...PAGE_SEO.about} />
      <PageHero
        crumb="About"
        image={IMAGES.about}
        eyebrow="About Montivex"
        title="We bridge warehouse operations and"
        accent="enterprise systems."
        sub="Many consultants understand systems. Many warehouse managers understand operations. Montivex understands both — and focuses on real-world execution, business outcomes, and measurable ROI."
      />

      {/* INTRO */}
      <section id="about">
        <div className="s-inner">
          <div className="about-grid">
            <div className="fade-up">
              <span className="s-eye">Who We Are</span>
              <h2>Practical supply chain expertise, built for execution.</h2>
              <p className="s-lead" style={{ marginBottom: 18 }}>Montivex was founded on a simple observation: the biggest gains in warehousing rarely come from buying new software — they come from making people, process, and systems work together.</p>
              <p className="s-lead">We partner with warehouses, distributors, 3PLs, manufacturers, and shippers to optimize how their supply chain technology supports the way they actually operate. Every engagement is grounded in your data and measured against outcomes you can put a number on.</p>
            </div>
            <div className="about-visual fade-up d2">
              <div className="about-card">
                <h3>Deep expertise across the full supply chain tech stack.</h3>
                <p>From WMS configuration to EDI monitoring to dashboard development — practical, hands-on expertise across every layer of your supply chain systems environment.</p>
                <div className="exp-tags">
                  {SYSTEMS.map((s, i) => (
                    <span className={`exp-tag ${i < 4 ? "hi" : ""}`} key={s}>{s}</span>
                  ))}
                </div>
              </div>
              <div className="about-float">
                <strong>End-to-End</strong>
                <span>Supply chain coverage</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* VALUES */}
      <section id="stats" style={{ position: "relative", overflow: "hidden" }}>
        <GlowLayer />
        <div className="s-inner" style={{ position: "relative" }}>
          <div className="stats-hdr fade-up">
            <span className="s-eye on-dark">What Sets Us Apart</span>
            <h2>The combination most consultants are missing</h2>
            <p className="s-lead">Enterprise-level knowledge, delivered with the practicality growing operations need.</p>
          </div>
          <div className="value-grid fade-up d1" style={{ marginTop: 8 }}>
            {VALUES.map((v) => {
              const Icon = v.icon;
              return (
                <div className="value-card" key={v.title}>
                  <div className="svc-icon"><Icon size={22} /></div>
                  <h4>{v.title}</h4>
                  <p>{v.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* HOW WE TACKLE ISSUES */}
      <section id="services">
        <div className="s-inner">
          <div className="fade-up" style={{ marginBottom: 48, maxWidth: 640 }}>
            <span className="s-eye">How We Tackle Issues</span>
            <h2>An honest, data-driven approach to real problems</h2>
            <p className="s-lead">We don't lead with a product or a template. We lead with questions, evidence, and a plan you can defend to your leadership team.</p>
          </div>
          <div className="approach-list">
            {APPROACH.map((a, i) => (
              <div className={`approach-item fade-up ${i ? "d1" : ""}`} key={a.title}>
                <div className="approach-num">{String(i + 1).padStart(2, "0")}</div>
                <div className="approach-body">
                  <h4>{a.title}</h4>
                  <p>{a.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaSection
        eyebrow="Work With Us"
        title="Let's build the case for"
        accent="change together."
        lead="Start with a free 60-minute discovery call. We'll listen first, then tell you honestly whether — and how — we can help."
      />
    </>
  );
}
